/* Upakarna collection page: infinite scroll + optional smart-recs fetch.
   Uses full-page fetch + DOMParser (Section Rendering API avoided for
   GoKwik/Foxify compatibility). Re-initialises after Dawn facet swaps. */
(function () {
  'use strict';

  function initGrid(wrap) {
    if (!wrap || wrap.dataset.upInit === '1') return;
    var grid = wrap.querySelector('#product-grid');
    var sentinel = wrap.querySelector('.up-scroll-sentinel');
    var loader = wrap.querySelector('.up-loadmore');
    var dataEl = wrap.querySelector('script[data-up-data]');
    if (!grid || !sentinel || !dataEl) return;
    wrap.dataset.upInit = '1';

    var cfg = {};
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) {}
    var totalPages = parseInt(cfg.total_pages, 10) || 1;
    var current = parseInt(cfg.current_page, 10) || 1;
    var loading = false;
    var done = current >= totalPages;
    if (loader) loader.style.display = done ? 'none' : 'block';

    function urlForPage(p) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', p);
      return u.pathname + u.search;
    }
    function stop() {
      done = true;
      if (loader) loader.style.display = 'none';
      io.disconnect();
    }
    function load() {
      loading = true;
      var p = current + 1;
      fetch(urlForPage(p), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) { throw new Error('http'); } return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('#product-grid');
          var items = src ? src.querySelectorAll(':scope > li.grid__item:not(.up-grid-injected)') : [];
          if (!items || !items.length) { stop(); return; }
          Array.prototype.forEach.call(items, function (it) {
            it.style.opacity = '0';
            it.style.transition = 'opacity .45s ease';
            grid.appendChild(it);
            requestAnimationFrame(function () { it.style.opacity = '1'; });
          });
          current = p;
          if (current >= totalPages) { stop(); }
        })
        .catch(function () { stop(); })
        .then(function () { loading = false; });
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading && !done) { load(); }
    }, { rootMargin: '500px 0px' });
    io.observe(sentinel);
  }

  function initRecs(el) {
    if (!el || el.dataset.upRecsDone === '1') return;
    el.dataset.upRecsDone = '1';
    var anchor = el.getAttribute('data-anchor');
    var base = el.getAttribute('data-recs-url');
    var limit = el.getAttribute('data-limit') || '12';
    if (!anchor || !base) { el.innerHTML = ''; return; }
    var url = base + '?section_id=up-recs&product_id=' + encodeURIComponent(anchor) +
              '&intent=related&limit=' + encodeURIComponent(limit);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelector('#up-recs-cards');
        el.innerHTML = cards ? cards.outerHTML : '';
      })
      .catch(function () { el.innerHTML = ''; });
  }

  function boot() {
    document.querySelectorAll('[data-up-collection]').forEach(initGrid);
    document.querySelectorAll('[data-up-recs]').forEach(initRecs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init after Dawn's own facet-filter AJAX swaps replace this section's
  // markup without a full page load (so infinite scroll / recs still wire
  // up on the fresh nodes). Previously this observed `document.body` for
  // the whole page lifetime, so its callback (two full-document
  // querySelectorAll sweeps) fired on EVERY DOM mutation anywhere on the
  // page, every cart-drawer re-render, wishlist heart toggle, mega-menu
  // panel open, etc., not just facet swaps. All collection/product-grid
  // markup this script cares about lives inside the main content area, so
  // scoping the observer there excludes header, cart-drawer and footer
  // mutations entirely while still catching every real facet swap (falls
  // back to document.body only if `main` genuinely isn't found).
  var mo = new MutationObserver(function () {
    document.querySelectorAll('[data-up-collection]').forEach(function (w) {
      if (w.dataset.upInit !== '1') { initGrid(w); }
    });
    document.querySelectorAll('[data-up-recs]').forEach(function (e) {
      if (e.dataset.upRecsDone !== '1') { initRecs(e); }
    });
  });
  mo.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
